import { User } from "oidc-react";
import { RootState, useAppSelector } from "../store";
import { UserRole } from "../store/auth";
import { getAppConfig } from "../config";

export function authIsEnabled() {
  const config = getAppConfig();
  return !config.disableAuth;
}

export const avatarColors: Record<string,string> = {
    purple: "#F1CCFF",
    blue: "#07ACFF",
    darkBlue: "#4A4CB1",
    green: "#6FD196",
    teal: "#62C8B3",
    lilac: "#C07FD1",
    slate: "#4D5D74",
    orange: "#ED6819",
    red: "#D84E41",
    lightRed: "#F8594D",
    seaBlue: "#3C98DB",
    grey: "#5F6477",
    racingGreen: "#254F3D",
    pink: "#BD3E79",
    lime: "#BCDB4A",
    salmon: "#F3B2A8",
    greenBlue: "#33768E",
    maroon: "#8E1B34",
    skyBlue: "#5DC5E7",
    burntOrange: "#E76134",
    navy: "#2B374E",
    sevilleOrange: "#F0923C",
    brown: "#936621",
    finn: "#6F2D6B",
};

export function parseUserRole(role: UserRole | null): string | null {
  switch (role) {
    case UserRole.ACTUARY:
      return "Actuary";
    case UserRole.ACCOUNT_MANAGER:
      return "AM";
    default:
      return null
  }
}

export function parseAppTitleFromUserRole(role: UserRole): string | null {
  switch (role) {
    case UserRole.ACTUARY:
      return "Actuarial";
    case UserRole.ACCOUNT_MANAGER:
      return "Account Management";
    default:
      return null
  }
}

export function useUserRole() {
  const { role } = useAppSelector((state: RootState) => state.auth);

  function isActuary(): boolean {
    return role === UserRole.ACTUARY;
  }

  function isAccountManager(): boolean {
    return role === UserRole.ACCOUNT_MANAGER;
  }

  function is(userRole: UserRole): boolean {
    return role === userRole;
  }

  return {
    is,
    isActuary,
    isAccountManager,
  }
}

function getHashOfString(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);
  return hash;
}

export function getUserAvatarColour(user?: User | null | undefined): string {
  if (!user) return avatarColors.purple;

  const colorIndex = getHashOfString(user.profile.email!) % Object.keys(avatarColors).length;
  return Object.values(avatarColors)[colorIndex];
}

export function getUserFullName(user: User | null | undefined) {
  return [
    user?.profile.GivenName || 'John',
    user?.profile.Surname || 'Smith',
  ].filter((d) => d).join(' ');
}
